import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  applyIfLatest,
  latestRequestInitialState,
  trackLatestRequests,
} from 'state/latestRequest';

import { LsKeys } from 'enums';
import {
  createArticle,
  deleteArticle,
  getArticle,
  getArticles,
  updateArticle,
} from 'state/thunks/articleThunk/articleThunk';

const initialState = {
  doctors: null,
  doctor: null,
  count: null,
  lastPage: null,
  page: null,
  user: null,
  isLoading: false,
  visits: [],
  articles: [],
  article: null,
  ...latestRequestInitialState,
};

/**
 * The filtered list read is guarded by `applyIfLatest`: a search string, a
 * status filter and a page all change it, so overlapping requests are routine
 * and the reducer must apply the newest REQUEST rather than the newest
 * response. See src/state/latestRequest.ts.
 */
const slice = createSlice({
  name: 'article',
  initialState,
  reducers: {
    clearArticle: state => {
      state.article = null;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    builder
      .addCase(
        getArticles.fulfilled,
        applyIfLatest(getArticles, (state, payload: any) => {
        console.log(payload);
        state.articles = payload;
        state.count = payload.count;
        state.lastPage = payload.lastPage;
        state.page = payload.page;
        }),
      )
      .addCase(getArticle.fulfilled, (state, action: PayloadAction<any>) => {
        state.article = action.payload;
      })
      .addCase(createArticle.fulfilled, (state, action: PayloadAction<any>) => {
        state.articles = action.payload;
        state.count = action.payload.count;
        state.lastPage = action.payload.lastPage;
        state.page = action.payload.page;
      })
      .addCase(deleteArticle.fulfilled, (state, action: PayloadAction<any>) => {
        console.log(action.payload);
        console.log(state.articles);
        state.articles.rows = state.articles.rows.filter(
          (el: any) => el.id !== action.payload,
        );
      })
      .addCase(updateArticle.fulfilled, (state, action: PayloadAction<any>) => {
        state.articles.rows = state.articles.rows.map((el: any) =>
          el.id === action.payload.id ? action.payload : el,
        );
      });

    // Matchers must come after every addCase.
    trackLatestRequests(builder, [getArticles]);
  },
});

export const articleActions = slice.actions;

export const articleReducer = slice.reducer;
